import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { ExistingEventServices } from "../../services/EventServices";
import RegisterUserEvent from "../../services/RegisterEventServices";
import Player from "@vimeo/player";
import { useLocation } from "react-router-dom";

const LivePlayer = ({ videoUrl, idEvent }) => {
    const [timeSpent, setTimeSpent] = useState({ hours: 0, minutes: 0, seconds: 0 });
    const [isPlaying, setIsPlaying] = useState(false);
    const iframeRef = useRef(null);
    const timerRef = useRef(null);
    const location = useLocation();

    const { token, idUser } = useAuth();

    useEffect(() => {
        const getExistUser = async () => {
            try {
                const userData = {
                    user_id: Number(idUser),
                    event_id: idEvent
                };

                const exist = await ExistingEventServices(token, userData);

                if (exist.length === 0) {
                    await RegisterUserEvent(token, userData);
                }
            } catch (error) {
                console.error("Error checking existing user:", error);
            }
        };

        getExistUser();
    }, [token, idEvent, idUser]);

    useEffect(() => {
        const player = new Player(iframeRef.current);
        startTimer();

        player.on('play', () => {
            setIsPlaying(true);
            startTimer();
        });

        player.on('pause', () => {
            setIsPlaying(false);
            stopTimer();
        });

        player.on('ended', () => {
            setIsPlaying(false);
            stopTimer();
        });

        const handleBeforeUnload = (event) => {
            stopTimer();
        }

        const handleUnload = (event) => {
            stopTimer();
        }

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handleUnload);

        return () => {
            player.off('play');
            player.off('pause');
            player.off('ended');
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleUnload);
            stopTimer();
        }
    }, []);

    useEffect(() => {
        return () => {
            if (isPlaying) {
                stopTimer();
                setIsPlaying(false);
            }
        }
    }, [location]);

    const startTimer = () => {
        // Recupera el tiempo guardado del localStorage, si existe
        const savedTime = { hours: 0, minutes: 0, seconds: 0 };
        const totalSeconds = savedTime.hours * 3600 + savedTime.minutes * 60 + savedTime.seconds;

        // Establece el tiempo actual
        setTimeSpent({
            hours: Math.floor(totalSeconds / 3600),
            minutes: Math.floor((totalSeconds % 3600) / 60),
            seconds: totalSeconds % 60
        });

        timerRef.current = setInterval(() => {
            setTimeSpent(prevTime => {
                const totalSeconds = prevTime.hours * 3600 + prevTime.minutes * 60 + prevTime.seconds + 1;
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
                const newTime = { hours, minutes, seconds };

                // Guarda el tiempo actualizado en localStorage
                localStorage.setItem(`videoTime-${idEvent}`, JSON.stringify(newTime));
                return newTime;
            });
        }, 1000);
    };

    const stopTimer = async () => {
        clearInterval(timerRef.current);

        // Envía el tiempo acumulado a un servicio
        try {
            console.log(localStorage.getItem(`videoTime-${idEvent}`))

            const userData = {
                user_id: Number(idUser),
                event_id: idEvent
            };

            const timeInComponent = JSON.parse(localStorage.getItem(`videoTime-${idEvent}`));

            await ExistingEventServices(token, userData).then(async (results) => {

                if (results['length'] > 0) {
                    const durationHourUser = results.data[0]['duration_hours'] || 0;
                    const durationMinuteUser = results.data[0]['duration_minutes'] || 0;

                    const userDataNew = {
                        user_id: idUser,
                        event_id: idEvent,
                        duration_hour: 0,
                        duration_minutes: 0
                    }

                    let shouldUpdate = false;

                    if (timeInComponent.hours > durationHourUser) {
                        userDataNew.duration_hour = timeInComponent.hours;
                        userDataNew.duration_minutes = durationMinuteUser;
                        shouldUpdate = true;
                    }

                    if (timeInComponent.minutes > durationMinuteUser) {
                        userDataNew.duration_hour = durationHourUser;
                        userDataNew.duration_minutes = timeInComponent.minutes;
                        shouldUpdate = true;
                    }
                    console.log(timeInComponent.minutes > durationMinuteUser, shouldUpdate)

                    if (shouldUpdate) {
                        await RegisterUserEvent(token, userDataNew).then((updateResults) => {
                            console.log('Updated:', updateResults);
                        });
                    }

                    console.log(durationHourUser, durationMinuteUser, timeInComponent)
                }
            })
        } catch (error) {
            console.error("Error sending time data:", error);
        }
    };

    return (
        <>
            <div className="relative pb-[56.25%] h-0 block md:block lg:block">
                <iframe
                    ref={iframeRef}
                    src={videoUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    width="620"
                    height="360"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                    title="Vimeo Video"
                ></iframe>
            </div>
        </>
    );
}


export default LivePlayer;